(function () {
	'use strict';

	if (!document.querySelector('.uvindex')) {
		return;
	}

	function fetchGlobalData() {
		const apiUrl = `/api/uvindex/max`;
		return fetch(apiUrl)
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then((data) => {
				return data.response;
			})
			.catch((error) => {
				console.error('There has been a problem fetching global data:', error);
				return [];
			});
	}

	function drawMap(uvData, geoData) {
		var svg = d3.select('#uvindex-map-svg');

		const maxWidth = 720;
		const maxHeight = 400;

		var maxTranslateX = maxWidth * 0.4,
			maxTranslateY = maxHeight * 0.5;

		var tooltip = d3.select('body').append('div').attr('class', 'uvindex-map-tooltip');

		var projection = d3
			.geoMercator()
			.scale(110)
			.translate([maxWidth / 2, maxHeight / 1.5]);

		var path = d3.geoPath().projection(projection);

		var g = svg.append('g');

		var zoom = d3
			.zoom()
			.scaleExtent([1, 8])
			.translateExtent([
				[-maxTranslateX, -maxTranslateY],
				[maxWidth + maxTranslateX, maxHeight + maxTranslateY],
			])
			.on('zoom', zoomed);

		d3.select('#zoom-in').on('click', function() {
			zoom.scaleBy(svg.transition().duration(500), 2)
		});

		d3.select('#zoom-out').on('click', function() {
			zoom.scaleBy(svg.transition().duration(500), 0.5)
		});

		svg.call(zoom);

		function zoomed() {
			var transform = d3.event.transform;
			g.attr('transform', transform);

			var newStrokeWidth = 1 / transform.k;
			g.selectAll('path').style('stroke-width', newStrokeWidth + 'px');

			var scaledRadius = 7 - (transform.k - 1) * 7 * 0.11;
			g.selectAll('circle').attr('r', scaledRadius);
		}

		// TODO: move to .less
		var tooltip = d3
			.select('body')
			.append('div')
			.attr('class', 'uvindex-map-tooltip')
			.style('position', 'absolute')
			.style('width', 'auto')
			.style('height', 'auto')
			.style('padding', '6px 12px 6px 12px')
			.style('color', '#fff')
			.style('font', '12px sans-serif')
			.style('background', 'rgba(0, 0, 0, 0.8)')
			.style('border', '1px solid black')
			.style('border-radius', '2px')
			.style('pointer-events', 'none')
			.style('opacity', '0');

		g.selectAll('path')
			.data(geoData.features)
			.enter()
			.append('path')
			.attr('fill', '#d9d9d9')
			.attr('d', path)
			.style('stroke', 'white');

		var colorScale = d3
			.scaleLinear()
			.domain([
				0, 0.99, 1, 1.99, 2, 2.99, 3, 3.99,
				4, 4.99, 5, 5.99, 6, 6.99, 7,
				7.99, 8, 8.99, 9, 9.99, 10, 10.99,
				11, 11.99, 12, 12.99, 13, 13.99,
				14, 14.99, 15, 15.99, 16, 16.99, 17,
				24,
			])
			.range([
				'rgba(190, 190, 190, 1)',
				'rgba(190, 190, 190, 1)',
				'rgba(78, 180, 0, 1)',
				'rgba(78, 180, 0, 1)',
				'rgba(160, 206, 0, 1)',
				'rgba(160, 206, 0, 1)',
				'rgba(247, 228, 0, 1)',
				'rgba(247, 228, 0, 1)',
				'rgba(248, 182, 0, 1)',
				'rgba(248, 182, 0, 1)',
				'rgba(248, 135, 0, 1)',
				'rgba(248, 135, 0, 1)',
				'rgba(248, 89, 0, 1)',
				'rgba(248, 89, 0, 1)',
				'rgba(232, 44, 14, 1)',
				'rgba(232, 44, 14, 1)',
				'rgba(216, 0, 29, 1)',
				'rgba(216, 0, 29, 1)',
				'rgba(255, 0, 153, 1)',
				'rgba(255, 0, 153, 1)',
				'rgba(181, 76, 255, 1)',
				'rgba(181, 76, 255, 1)',
				'rgba(153, 140, 255, 1)',
				'rgba(153, 140, 255, 1)',
				'rgba(133, 120, 235, 1)',
				'rgba(133, 120, 235, 1)',
				'rgba(113, 100, 215, 1)',
				'rgba(113, 100, 215, 1)',
				'rgba(93, 80, 195, 1)',
				'rgba(93, 80, 195, 1)',
				'rgba(73, 60, 175, 1)',
				'rgba(73, 60, 175, 1)',
				'rgba(53, 40, 155, 1)',
				'rgba(53, 40, 155, 1)',
				'rgba(33, 20, 135, 1)',
				'rgba(33, 20, 135, 1)',
			]);

		g.selectAll('circle')
			.data(uvData)
			.enter()
			.append('circle')
			.attr('cx', function (d) {
				return projection([d.Longitude, d.Latitude])[0];
			})
			.attr('cy', function (d) {
				return projection([d.Longitude, d.Latitude])[1];
			})
			.attr('r', 6)
			.style('fill', function (d) {
				return colorScale(d.MaxUvIndex);
			})

			.on('mouseover', function (d) {
				tooltip
					.html('<div>' + d.Name + "</div><div style='margin-top: 8px;'>UV-index: " + d.MaxUvIndex.toLocaleString().replace('.',',') + '</div>')
					.style('left', d3.event.pageX + 10 + 'px')
					.style('top', d3.event.pageY - 10 + 'px')
					.style('opacity', '1');
			})
			.on('mouseout', function () {
				tooltip.style('opacity', '0');
			});
	}

	function fetchDataAndDrawMap() {
		const geoDataPromise = d3.json(
			'https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/world.geojson'
		);
		const globalDataPromise = fetchGlobalData();

		Promise.all([geoDataPromise, globalDataPromise])
			.then(([geoData, globalUVData]) => {
				drawMap(globalUVData.location, geoData);
			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			});
	}

	fetchDataAndDrawMap();
})();
